import {
    addToChainAfter,
    ApiHandlerDiscreteParameter,
    HasOnSuccess,
    replaceInChain,
} from "@insite/client-framework/HandlerCreator";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import { getOrderState } from "@insite/client-framework/Store/Data/Orders/OrdersSelectors";
import {
    chain,
    PopulateApiParameter,
    SendDataToApi,
} from "@insite/client-framework/Store/Pages/OrderDetails/Handlers/Reorder";
import { CartLineCollectionModel, CartLineModel, OrderLineModel } from "@insite/client-framework/Types/ApiModels";
import { addToCartEvent } from "@WhiteCap/Common/Utillities/CustomTracking";

type HandlerType = ApiHandlerDiscreteParameter<HasOnSuccess, CartLineCollectionModel, CartLineCollectionModel>;

export const ReorderPromoItemsNoZeroPrice: HandlerType = props => {
    const state = props.getState();
    const order = getOrderState(state, state.pages.orderDetails.orderNumber);
    if (!order.value) {
        throw new Error("Reorder was called but there was no order available");
    }

    // EC-1356 Filter out order lines with zero unit price or zero quantity
    const cartLines = order?.value.orderLines?.filter(line => line.unitNetPrice > 0 && line.qtyOrdered > 0);

    // EC-1356  Map the filtered order lines to the expected API format
    props.apiParameter = {
        cartLines: cartLines?.map(
            (line: OrderLineModel) =>
                ({
                    productId: line.productId,
                    qtyOrdered: line.qtyOrdered <= 0 ? 1 : line.qtyOrdered,
                    unitOfMeasure: line.unitOfMeasure,
                } as CartLineModel),
        ),
    } as CartLineCollectionModel;
};

export const trackAddtoCartEvent: HandlerType = props => {
    const session = getSession(props.getState());
    const state = props.getState();
    const cart = getCurrentCartState(state).value;
	const order = getOrderState(state, state.pages.orderDetails.orderNumber);
	const cartLines = order?.value?.orderLines?.filter(line => line.unitNetPrice > 0 && line.qtyOrdered > 0);
    if (cartLines && cart) {
        const newItem =cartLines.map(item => {
            return {
                item_name: item?.shortDescription ? item.shortDescription : item.description,
                item_id: item.productErpNumber,
                quantity: item.qtyOrdered,
                price: item.unitNetPrice,
                item_brand: item?.brand?.name,
            };
        });
        // Calculate value = sum of (price × quantity)
        const totalValue = cartLines.reduce((sum, item) => {
            return sum + (item.unitNetPrice * item.qtyOrdered);
        }, 0);

        addToCartEvent({
            event: "add_to_cart",
            ecommerce: {
                currency: session?.currency?.currencyCode,
                value: totalValue,
                items: [...newItem],
            },
        });
    }
};

addToChainAfter(chain, SendDataToApi, trackAddtoCartEvent);

// EC- 1356:- Replace the default PopulateApiParameter handler in the reorder chain
// EC- 1356:- with the custom handler that excludes zero-price promotional items
replaceInChain(chain, PopulateApiParameter, ReorderPromoItemsNoZeroPrice);